import { State } from '../../types'

export const getTimestampStr = (state: State) => state.System.timestampStr
export const getLoadingData = (state: State) => state.System.loadingData
